export default __webpack_public_path__ + "static/media/PEGAUS_HEALTH_ELEMENTS-01.452007c3.png";